/**
 * @desc allocationMasterFinishPushEbs
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(
  params: API.fulfilment.test.allocationMasterFinishPushEbs.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/test/allocationMasterFinishPushEbs`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
